import { api } from './api';

// Define a service using a base URL and expected endpoints
export const scriptApi = api.injectEndpoints({
  reducerPath: 'scriptApi',
  tagTypes: ['Scripts'],
  endpoints: (builder) => ({
    getScripts: builder.query({
      query: () => ({
        url: `/api/administration/scripts`,
        method: 'GET'
      }),
      providesTags: ['Scripts']
    }),
    getScriptByCode: builder.query({
      query: (code) => ({
        url: `/api/administration/scripts/${encodeURIComponent(code)}`,
        method: 'GET'
      }),
      providesTags: (result, error, code) => [{ type: 'Scripts', id: code }]
    }),
    createScript: builder.mutation({
      query: ({ name, content }) => ({
        url: `/api/administration/scripts`,
        method: 'POST',
        body: { name, content }
      }),
      invalidatesTags: ['Scripts']
    }),
    updateScript: builder.mutation({
      query: ({ code, content }) => ({
        url: `/api/administration/scripts/${encodeURIComponent(code)}`,
        method: 'PUT',
        body: { content: content }
      }),
      invalidatesTags: (result, error, { code }) => [{ type: 'Scripts', id: code }, 'Scripts']
    }),
    deleteScript: builder.mutation({
      query: (code) => ({
        url: `/api/administration/scripts/${encodeURIComponent(code)}`,
        method: 'DELETE'
      }),
      invalidatesTags: ['Scripts']
    }),
    bulkDeleteScripts: builder.mutation({
      query: (scriptCodes) => ({
        url: `/api/administration/scripts`,
        method: 'DELETE',
        body: scriptCodes
      }),
      invalidatesTags: ['Scripts']
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetScriptsQuery,
  useGetScriptByCodeQuery,
  useCreateScriptMutation,
  useUpdateScriptMutation,
  useDeleteScriptMutation,
  useBulkDeleteScriptsMutation
} = scriptApi;
